import { render } from "./DistributionTourPage.vue?vue&type=template&id=5ab5e62a&ts=true"
import script from "./DistributionTourPage.vue?vue&type=script&lang=ts"
export * from "./DistributionTourPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__